import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { mobileLogin } from "../../apis";
import { sendToast } from "../../utilities/utils";
import { openPopup } from "../../reducers/popup";
import { useDispatch } from "react-redux";
import { POPUP_NAME } from "../../utilities/constants";
import ImgLogo from "../../assets/img/vieon-logo.png";
import { validatePhone } from "../../services/popup";
import { getProfileAsync } from "../../reducers/user";
import ModalHeader from "./ModalHeader";
import Button from "../Button/Button";

const ModalLogin = () => {
  const dispatch = useDispatch();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [enable, setEnable] = useState(false);
  const [isShowForm, setShowForm] = useState(false);

  useEffect(() => {
    if (phone && password && !phoneError) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [phone, password, phoneError]);

  const onPhoneChange = (e) => {
    const value = e?.target?.value || "";
    const REGEX_PHONE_NUMBER = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
    if (REGEX_PHONE_NUMBER.test(value) || !value) {
      if (value.length <= 10) {
        setPhone(value || "");
        phoneError && setPhoneError("");
      }
    }
  };

  const onKeyDown = (e) => {
    if (e?.keyCode === 13) {
      onSubmit();
    }
  };

  const onPhoneBlur = (e) => {
    if (!e?.target?.value) return;
    const { valid, errorMsg } = validatePhone(e?.target?.value || "");
    if (!valid && errorMsg) setPhoneError(errorMsg);
  };

  const onPasswordChange = (e) => {
    setPassword(e?.target?.value || "");
  };

  const onSubmit = (e) => {
    e && e.preventDefault();
    const { valid, errorMsg } = validatePhone(phone);
    if (valid) {
      onMobileLogin();
    } else if (errorMsg) {
      setPhoneError(errorMsg);
    }
  };

  const onMobileLogin = () => {
    mobileLogin({ phone, password })
      .then((res) => {
        const accessToken= res?.data?.result?.access_token;
        if (accessToken) {
          dispatch(getProfileAsync(accessToken));
          dispatch(openPopup({}));
          sendToast("Đăng nhập thành công");
          return
        } 
        if(res.data.code === 400){
          sendToast(res.data.message);
          return
        }
        throw new Error()
      })
      .catch(() => {
        sendToast("Có lỗi xảy ra, vui lòng thử lại");
      });
  };

  const onClose = () => {
    dispatch(openPopup({}));
  };

  const onForgetPassword = (e) => {
    window.open("https://vieon.vn/auth", "_blank");
  };
  const onRegister = (e) => {
    window.open("https://vieon.vn/auth", "_blank");
  };

  const handleShowForm = () => {
    setShowForm(!isShowForm);
  };

  const handleRegisterVip = () => {
    window.open("https://vieon.vn/mua-goi/", "_blank");
  };

  return (
    <Modal onClose={onClose}>
      <div className="w-full overflow-hidden relative z-20 px-[4vw] h-[130vw] md:h-full">
        <button
          className="absolute z-10 w-4 h-4 top-2 right-7 md:top-[1vw] md:right-[5vw]"
          title="Close"
          onClick={onClose}
        >
          <svg
            className="w-4 h-auto"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8323 10.0156L19.6199 2.22773C20.1267 1.72117 20.1267 0.902117 19.6199 0.39555C19.1133 -0.111017 18.2943 -0.111017 17.7877 0.39555L9.99989 8.18339L2.21228 0.39555C1.70548 -0.111017 0.88667 -0.111017 0.380103 0.39555C-0.126701 0.902117 -0.126701 1.72117 0.380103 2.22773L8.16771 10.0156L0.380103 17.8034C-0.126701 18.31 -0.126701 19.129 0.380103 19.6356C0.632556 19.8883 0.964494 20.0152 1.29619 20.0152C1.62789 20.0152 1.95959 19.8883 2.21228 19.6356L9.99989 11.8478L17.7877 19.6356C18.0404 19.8883 18.3721 20.0152 18.7038 20.0152C19.0355 20.0152 19.3672 19.8883 19.6199 19.6356C20.1267 19.129 20.1267 18.31 19.6199 17.8034L11.8323 10.0156Z"
              fill="#fff"
            />
          </svg>
        </button>
        {!isShowForm ? (
          <div className="main-bg">
            <div className="container h-full max-w-[450px]">
              <ModalHeader
                classNamesContainer="relative top-0"
                classNamesLogoRapViet="!w-[50%] mx-auto pt-4"
                classNamesLogoBrand="mx-auto pt-4 md:-translate-y-10"
              />

              <div className="flex flex-col w-[95%] mx-auto items-center h-full px-6 py-6 pb-8 text-white translate-y-6 sm:px-5 form-bg">
                <h3 className="pb-4 mt-1 text-xl text-center md:text-3xl 2xl:text-4xl md:mb-3">
                  Đăng nhập để tham gia bình chọn
                </h3>
                <p className="text-center text-gray-200 font-normal text-sm lg:text-xl tracking-[0.44px] mb-3">
                  Nhận ngay 1 lượt bình chọn mỗi ngày
                </p>
                <Button
                  text="Đăng nhập"
                  type="linear"
                  onClickButton={handleShowForm}
                  classNames="py-2 text-lg md:text-xl text-white !border-none !bg-[#008cd5]"
                />

                <p className="text-center text-gray-200 font-normal text-sm lg:text-xl tracking-[0.44px] mb-3 pt-3 md:pt-5">
                  hoặc Đăng ký VIP để nhận ngay 5 lượt Bình chọn mỗi ngày
                </p>
                <Button
                  text="Đăng ký VIP"
                  type="outline"
                  onClickButton={handleRegisterVip}
                  classNames="py-2 text-lg md:text-xl bg-transparent border-[0.5px] !border-[#60c7f6]"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="border border-[#60c7f6] p-5 md:p-4 bg-black">
            <div className="bg-gradient-to-b from-white to-[#60c7f6] bg-clip-text text-transparent text-[28px] lg:text-28 uppercase text-center font-bold mb-[12px] lg:mb-[32px]">
              Đăng nhập
            </div>
            <div className="text-white text-[14px] lg:text-[18px] lg:text-28 mb-[12px] lg:mb-[24px] flex items-end justify-center">
              <div className="inline-block leading-[normal]">
                Hãy đăng nhập với tài khoản&nbsp;
              </div>
              <a
                className="max-w-[64px] lg:max-w-[94px] inline-block"
                href="https://vieon.vn"
                title="Hãy đăng nhập với tài khoản VieON"
              >
                <img src={ImgLogo} alt="Logo VieON" />
              </a>
            </div>
            <form className="flex flex-col items-center" onSubmit={onSubmit}>
              <div className="block w-full focus-visible:border-[#4facfe] mb-4 lg:mb-6">
                <span
                  className="block mb-2 text-sm text-white lg:text-lg"
                  htmlFor="userName"
                >
                  Tên đăng nhập
                </span>
                <div className="px-3 lg:px-6 border-2 border-[#4facfe] rounded focus:border-opacity-100 focus-visible:border-opacity-100 border-opacity-50 hover:border-opacity-100 transition">
                  <input
                    id="userName"
                    autoComplete="on"
                    className="block w-full text-sm font-normal text-white bg-transparent border-none h-11 lg:h-14 lg:text-lg focus-visible:outline-none"
                    placeholder="Số điện thoại"
                    value={phone}
                    onBlur={onPhoneBlur}
                    onChange={onPhoneChange}
                    onKeyDown={onKeyDown}
                  />
                </div>
                {!!phoneError && (
                  <span className="mt-2 text-sm text-red-600 lg:text-lg">
                    {phoneError}
                  </span>
                )}
              </div>
              <div className="block w-full mb-4 lg:mb-6">
                <span
                  className="block mb-2 text-sm text-white lg:text-lg"
                  htmlFor="passWord"
                >
                  Mật khẩu
                </span>
                <div className="px-3 lg:px-6 border-2 border-[#4facfe] rounded focus:border-opacity-100 focus-visible:border-opacity-100 border-opacity-50 hover:border-opacity-100 transition">
                  <input
                    id="passWord"
                    type="password"
                    autoComplete="on"
                    className="block w-full text-sm font-normal text-white bg-transparent border-none h-11 lg:h-14 lg:text-lg focus-visible:outline-none"
                    placeholder="Mật khẩu"
                    value={password}
                    onChange={onPasswordChange}
                    onKeyDown={onKeyDown}
                  />
                </div>
                <div className="flex justify-between pt-2">
                  <div className="flex-none">
                    <div
                      className="text-[14px] lg:text-[18px] text-[#4facfe] hover:underline cu flex w-fit cursor-pointer"
                      title="Quên mật khẩu"
                      onClick={onForgetPassword}
                    >
                      Quên mật khẩu?
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center justify-center w-full mb-4 lg:mb-6">
                <button
                  className="text-white bg-center bg-no-repeat h-[40px] w-[160px] lg:h-[60px] lg:w-[248px] uppercase font-bold text-[14px] lg:text-[22px] enabled:transition enabled:hover:bg-[#0acde7] border-[0.7px] border-[#0ee2ff] rounded"
                  type="button"
                  disabled={!enable || phoneError}
                  onClick={onSubmit}
                >
                  Đăng nhập
                </button>
                <div className="flex text-[14px] lg:text-[18px] mt-3">
                  <span className="mr-2 text-white">
                    Bạn chưa có tài khoản?
                  </span>{" "}
                  <span
                    className="text-[#4facfe] hover:underline cursor-pointer flex w-fit font-bold"
                    href="https://vieon.vn"
                    title="Đăng ký ngay"
                    onClick={onRegister}
                  >
                    Đăng ký ngay
                  </span>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default React.memo(ModalLogin);
